import React, { useCallback } from "react";
import RoundTextBlack from "../../assets/YogRoundBlack.png";
import { Round, ScrollButton } from "./Home.styles";

/**
 * RotatingBadge
 * Renders an animated circular badge with a scroll-down arrow.
 * Clicking the arrow smoothly scrolls to the element matching `targetId`.
 *
 * @param {string} targetId - The id of the section to scroll to on click.
 */
const RotatingBadge = ({ targetId = "about" }) => {
  const handleScroll = useCallback(() => {
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, [targetId]);

  return (
    <Round aria-hidden="true">
      <ScrollButton
        onClick={handleScroll}
        aria-label={`Scroll to ${targetId} section`}
        aria-hidden="false" // override parent aria-hidden for this interactive element
      >
        &#x2193;
      </ScrollButton>
      <img src={RoundTextBlack} alt="" />
    </Round>
  );
};

export default React.memo(RotatingBadge);
